import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Component, Injector, Input, OnInit } from '@angular/core';
import { RfidCard } from '@models/rfidCard';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RfidCardsService } from '@services/entity/rfidCards.service';

@Component({
  selector: 'app-remove-rfid-assignment-dialog-content',
  templateUrl: './remove-rfid-assignment-dialog-content.component.html',
  styleUrls: ['./remove-rfid-assignment-dialog-content.component.scss']
})
export class RemoveRfidAssignmentDialogContentComponent extends AbstractDialogContent implements OnInit {

  public className = 'RemoveRfidAssignmentDialogContentComponent';

  @Input() private rfidCard: RfidCard;

  constructor(
    public activeModal: NgbActiveModal,
    private rfidCardService: RfidCardsService,
    injector: Injector) {
    super(activeModal, injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  onConfirmClick() {
    this.rfidCard.userId = null;

    this.rfidCardService.updateEntity(this.rfidCard).subscribe(result => {
      this.activeModal.close();
    }, error => {

    });
  }
}
